module.exports = __webpack_public_path__ + "img/calendar-range.3ae25305.svg";